import React from "react";
import "../layout/sec4.css";

const Sec4Card = (props) => {
  return (
    <div className="sec4-card">
      <div className="sec4-card-content">
        <img src={props.img} className="sec4-img" alt="" />
        <h3 className="sec4-card-title">{props.title}</h3>
        <p className="sec4-card-text">{props.text}</p>
      </div>
    </div>
  );
};

export default Sec4Card;